module.exports = __webpack_public_path__ + "img/team.99a77216.svg";